import { useState, useContext } from "react";
import * as Yup from "yup";
import { Form, Formik, ErrorMessage } from "formik";
import { useFormBase } from "ComponentHooks/useFormBase";
import { EditableContext } from "common/EditableContextProvider";

export const ImportModal = () => {
    let { context } = useContext(EditableContext);
    let formBase = useFormBase();
    const defaultItem = {
        file: null,
    };

    const FILE_SIZE = 10 * 1024 * 1024; // 10 MB
    const SUPPORTED_FORMATS = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    const validationSchema = new Yup.object({
        file: Yup.mixed()
            .required("El archivo es necesario.")
            .test("fileSize", "El archivo no deber ser mayor a 10Mb", (value) => {
                return value && value.size <= FILE_SIZE;
            })
            .test("fileFormat", "Formato no soportado.", (value) => {
                return value && SUPPORTED_FORMATS.includes(value.type);
            }),
    });

    const submit = (values) => {
        console.log(context);

        context.importExcel(values);
    };

    return (
        <div>
            <div className="">
                <div className="p-2">
                    <h4>Descarga de plantilla</h4>

                    <dir className="row border">
                        <div className="col-md p-2">
                            Plantilla
                        </div>
                        <div className="col-md">
                            <a
                                href="/docs/lista_contactos.xlsx"
                                className="btn btn-sm btn-link"
                            >
                                <i className="fas fa-download pe-2"></i>
                                lista_contactos.xlsx
                            </a>
                        </div>
                    </dir>
                    <div className="p-2">
                        Ejemplo de llenado de la plantilla
                        <table className="table table-sm table-bordered">
                            <thead>
                                <tr>
                                    <th>nombre_de_lista</th>
                                    <th>nombre</th>
                                    <th>número</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Lista1</td>
                                    <td>Simón Rodriguez</td>
                                    <td>59175300000</td>
                                </tr>
                                <tr>
                                    <td>Lista2</td>
                                    <td>Andrés Calamaro</td>
                                    <td>51941736546</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="border-top p-2 rounded" style={{ backgroundColor: '#ececec'}}>
                    <h4>Subir archivo</h4>

                    <Formik
                        initialValues={defaultItem}
                        validationSchema={validationSchema}
                        onSubmit={submit}
                        enableReinitialize={true}
                    >
                        {
                            (formik) => (
                                <Form>
                                    <div className="mb-3">
                                        <div className="row">
                                            <div className="col-md-auto py-1">
                                                <label htmlFor="">Archivo:</label>
                                            </div>
                                            <div className="col-md">
                                                <input
                                                    type="file"
                                                    className="form-control form-control-sm"
                                                    accept={SUPPORTED_FORMATS[0]}
                                                    onChange={(e) => formik.setFieldValue('file', e.currentTarget.files[0]) }
                                                />
                                                <ErrorMessage name="file" component={formBase.FormError} />
                                            </div>
                                        </div>
                                    </div>
                                    <button className="btn btn-sm btn-dark mb-3 w-100"
                                        disabled={context.loadingUpload}
                                    >
                                        {
                                            (context.loadingUpload) ? "Cargando..." : "Subir Archivo"
                                        }
                                    </button>
                                </Form>
                            )
                        }
                    </Formik>

                </div>
            </div>
        </div>
    );
};
